<template>
    <section class="container">
        <div class="row">
            <div class="col">
                Explore
            </div>
        </div>
    </section>
</template>

<script setup>
</script>

<style scoped></style>